import { useRef } from "react";
import { toast } from "react-toastify";

export const FileUploader = ({
  handleFile,
  isRequired,
  buttonLabel = "Resume",
  isDisabled,
 fileTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ],

}) => {  
  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);

  // Programmatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      handleFile(false);
      return;
    }

    // Allowed MIME types
    const allowedFileTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

      // Validate file type
    if (!fileTypes.includes(file.type)) {
      const readableTypes = fileTypes.map(type => {
        const parts = type.split('/');
        return parts[1] ? `.${parts[1]}` : type;
      }).join(', ');
      
      toast.error(`Unsupported file type. Allowed types: ${readableTypes}`);
      handleFile(null);
      return;
    }

    // Maximum file size: 5MB (in bytes)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB = 5 * 1024 KB * 1024 Bytes

    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size exceeds the 5MB limit");
      handleFile(false); // Reject the file
      return;
    }

    // Pass the valid file to the parent component
    handleFile(file);
  };

  return (
    <>
      <button
        className="btn-uploader"
        disabled={isDisabled}
        style={{

          // backgroundColor: isDisabled ? "#e0e0e0" : "#007bff", // Grey when disabled
          color: isDisabled ? "#a0a0a0" : "white", // Light grey text when disabled
paddingInline:"12px",
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.7 : 1,
        }}
        onClick={handleClick}
      >
        <i className="fa fa-upload"></i>&nbsp;{buttonLabel}&nbsp;
     {isRequired ?  <span className="required"> *</span>:null}
      </button>
      <input
        disabled={isDisabled}
        type="file"
        accept="image/jpeg,image/jpg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: "none" }} // Make the file input element invisible
      />
    </>
  );
};

export default FileUploader;
